import React from "react";
import {Checkbox, FormControlLabel, FormHelperText, Grid, Stack} from "@mui/material";
import {Controller} from "react-hook-form";
import Label from "../../Label";
import checkBoxIcon from "assets/icon/check_box.svg"
import checkBoxCheckedIcon from "assets/icon/check_box_checked.svg"
import TextOtherField from "../TextOtherField";
import ErrorMessage from "../ErrorMessage";

export const CheckBox = ({field, type, listAnswer, control, name,}) => {
    const handleChange = (answerId) => (event) => {
        const value = field.value || [];
        const index = value.findIndex(item => item.answerId === answerId);
        if (index >= 0) {
            value.splice(index, 1)
        }
        if (event.target.checked) {
            value.push({answerId})
        }
        field.onChange([...value])
    }
    const checkIndex = (answerId) => {
        const value = field.value || [];
        return value.findIndex(item => item.answerId === answerId)
    }
    return (
        <Stack>
            {
                listAnswer.map(answer => (
                    <>
                        <FormControlLabel
                            ref={field.ref}
                            key={answer.answerId}
                            label={answer.title}
                            sx={{
                                alignItems: "flex-start",
                                "& .MuiCheckbox-root": {
                                    flexShrink: 0,
                                    padding: "4px 9px",
                                },
                            }}
                            control={
                                <Checkbox
                                    icon={type !== "d" ? <img style={{width: 20, height: 20}} src={checkBoxIcon} alt=""/>:undefined}
                                    checkedIcon={type !== "d" ?
                                        <img style={{width: 20, height: 20}} src={checkBoxCheckedIcon} alt=""/>:undefined}
                                    onChange={handleChange(answer.answerId)}
                                    checked={checkIndex(answer.answerId) >= 0}
                                />
                            }
                        />
                        {checkIndex(answer.answerId) >= 0 && answer.hasText &&
                            <TextOtherField control={control} name={`${name}.${checkIndex(answer.answerId)}.text`}/>}
                    </>
                ))
            }
        </Stack>
    )
}
export default function CheckboxField({
                                          control,
                                          name,
                                          label,
                                          listAnswer,
                                          require,
                                          type
                                      }) {
    return (
        <Grid item xs={12}>
            <Label require={require}>{label}</Label>
            <Controller
                control={control}
                name={name}
                render={({field, fieldState: {error}}) => {
                    return (
                        <>
                            <FormHelperText error>
                                <ErrorMessage message={error?.message}/>
                            </FormHelperText>
                            <CheckBox field={field} control={control} type={type} name={name} listAnswer={listAnswer}/>
                        </>
                    );
                }}
            />
        </Grid>


    );
}

